import { render, staticRenderFns } from "./MedicationIcon.vue?vue&type=template&id=2471d374&scoped=true&"
import script from "./MedicationIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MedicationIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471d374",
  null
  
)

export default component.exports